module.exports = __webpack_public_path__ + "static/media/431158914_933482455103515_2959543396461720805_n.dfc479a9.jpg";